import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_al75e43rzb: FaireBrandEntity = {
  token: "b_al75e43rzb",
  type: "brand",
  name: "Golden Thread",
  avatarUrl:
    "https://cdn.faire.com/fastly/c61c25653960ee8701eb61afc0ee380347ebe256bf7c34b06b72c6ac52088d14.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1c7d9623d38df5f139587daef1ec0b457abc56a2ecf10dc2f1af584fbbb8907a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c61c25653960ee8701eb61afc0ee380347ebe256bf7c34b06b72c6ac52088d14.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1c7d9623d38df5f139587daef1ec0b457abc56a2ecf10dc2f1af584fbbb8907a.png",
  location: "Houston, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "Golden Thread is a luxe line of customizable jewelry hand-made in Houston, Texas, with the perfect juxtaposition of personalization and style, new trends and timeless classics. Houston native, Jennifer Welker founded Golden Thread in 2010 to redefine classic monogrammed jewelry, with a focus on quality, innovation, sophistication and affordable style. \nAs a mother and former neonatal nurse, Jennifer personally designs each piece in our Houston studio with the intent for women to feel effortlessly chic from the daily mundane in the carpool line to the red carpet and everywhere in between. Our desire is for each piece to be packed with heirloom quality, but invaluable in sentiment that would be passed down through the generations with imperishable value far beyond the diamond count or metals we use. Jewels that are one-of-a-kind, full of meaning, deeply cherished and prized celebratory pieces that speak of your story.\n\nGolden Thread, today, has a lot to be excited about! We have been featured on the cover of WWD, as well as in leading fashion magazines like Vogue, W Magazine, In Style, Lucky, People Style Watch, Redbook, and Teen Vogue. We have also been featured on national broadcasts like NBC’s TODAY Show. We have quickly emerged as a celebrity favorite of Taylor Swift, Emma Stone, Pippa Middleton, Lupita Nyong’o, Anna Kendrick, Camila Alves, Sophia Bush, Jenna Bush and Alessia Cara among other industry notables.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:18.280Z",
    importedBy: "entity-db-cli",
  },
};
